
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

///////////////////////////////////////////////////////////////////////////////
// START OLD SUBMODULE CRAP

require('@node/popper.js/dist/umd/popper.min.js');
require('@node/bootstrap/dist/js/bootstrap.min.js');
require('@sass/lsau-ux/libraries/data-tables/lsau-ux-data-tables.min.js');

// END   OLD SUBMODULE CRAP
///////////////////////////////////////////////////////////////////////////////

window.bus = new Vue();
window.store = {
    orders: {
        loaded: false,
    },

    misc: {
        syncRequestsPending: 0,
    },
};

import Vue from 'vue';
import { store } from './store/store';
import sauFunctions from './store/sauFunctions';
// import jqueryFunctions from './store/jqueryFunctions';
import Vuelidate from 'vuelidate';
import BootstrapVue from 'bootstrap-vue/dist/bootstrap-vue.esm';
import Moment from 'moment';
import VueSweetalert2 from 'vue-sweetalert2';
import VueCurrencyFilter from 'vue-currency-filter';
import VueNumeric from 'vue-numeric';
import VueLazyload from 'vue-lazyload';
import InputTag from 'vue-input-tag';
import VueRouter from 'vue-router';
import VueMoment from 'vue-moment';


Vue.use(VueLazyload, {
    preLoad: 1.3,
    error: 'dist/error.png',
    loading: 'dist/loading.gif',
    attempt: 1
})

Vue.use(VueRouter);

window.Vue = Vue;
window.moment = Moment;
// global websocket client
// window.socket = socket

Vue.use(BootstrapVue);
Vue.use(Vuelidate);
Vue.use(VueSweetalert2);
Vue.use(VueNumeric);
Vue.use(InputTag);
Vue.use(VueMoment); // Date filtering


/**
 * Global Mixins
 */
Vue.mixin(sauFunctions);

/**
 * Plugins
 */
import DynamicForm from './plugins/dynamic-form';
import PasswordStrength from './plugins/password-strength';
Vue.use(DynamicForm);
Vue.use(PasswordStrength);

/**
 * Utility Components
 */
import ButtonOnce from './plugins/button-once';
import MarkdownPreview from './plugins/markdown-preview';
import IconComponent from 'laravel-mix-vue-svgicon/IconComponent.vue';
Vue.use(ButtonOnce, {});
Vue.use(MarkdownPreview, {});
Vue.component('icon', IconComponent);


/**
 * SAU Utilities
 */
import Preloader from './components/utilities/Preloader';
import PageNav from './components/utilities/PageNav';
import SauTemplate from './components/utilities/SauTemplate';
import SauLoading from './components/utilities/SauLoading';
import SauSpinner from './components/utilities/SauSpinner';
import SauApiroResponse from './components/utilities/SauApiroResponse';
import UtilitySupport from './components/utilities/Support';
import Profile from './components/utilities/Profile';
import PaymentMethods from './components/utilities/PaymentMethods';
import Bpay from './components/utilities/Bpay';
import PasswordChange from './components/utilities/PasswordChange';
import PinChange from './components/utilities/PinChange';
import GooglePlacesSearch from './components/utilities/GooglePlacesSearch';
import _RequestExtension from './components/billing/_RequestExtension';
import RequestPermission from './components/utilities/RequestPermission';
import SupportFeedback from './components/utilities/SupportFeedback';
import PasswordReset from './components/utilities/PasswordReset';
import MsgInline from './components/utilities/MsgInline';
import CartIcon from './components/utilities/CartIcon';
import UpdateProfileLink from './components/utilities/_UpdateProfileLink';

import RequestAdditionalInformation from './components/utilities/RequestAdditionalInformation';

Vue.component('sau-preloader', Preloader);
Vue.component('sau-page-nav', PageNav);
Vue.component('sau-template', SauTemplate);
Vue.component('sau-loading', SauLoading);
Vue.component('sau-spinner', SauSpinner);
Vue.component('sau-apiro-response', SauApiroResponse);
Vue.component('sau-utility-support', UtilitySupport);
Vue.component('sau-utility-profile', Profile);
Vue.component('sau-utility-payment-methods', PaymentMethods);
Vue.component('sau-utility-bpay', Bpay);
Vue.component('sau-utility-account-password', PasswordChange);
Vue.component('sau-utility-account-pin', PinChange);
Vue.component('sau-utility-address-search', GooglePlacesSearch);
Vue.component('sau-request-extension', _RequestExtension);
Vue.component('sau-request-permission', RequestPermission);
Vue.component('sau-utility-support-feedback', SupportFeedback);
Vue.component('sau-utility-account-password-reset', PasswordReset);
Vue.component('sau-utility-msg-inline', MsgInline);
Vue.component('sau-cart-icon', CartIcon);
Vue.component('sau-update-profile-link', UpdateProfileLink);
Vue.component('sau-request-additional-information', RequestAdditionalInformation);

/**
* Dashboard
*/
import Dashboard from './components/dashboard/Dashboard';
Vue.component('sau-dashboard', Dashboard);

/**
* Account
*/
import Login from './components/account/Login';
import Registration from './components/account/Registration';
import _AccountUpdate from './components/account/_AccountUpdate';
import TwoFactor from './components/account/TwoFactor';
import _ContactUpdate from './components/account/_ContactUpdate';
import _ApiTokens from './components/account/_ApiTokens';
Vue.component('sau-account-login', Login);
Vue.component('sau-account-register', Registration);
Vue.component('sau-account-update', _AccountUpdate);
Vue.component('sau-account-twofactor', TwoFactor);
Vue.component('sau-account-contact-update', _ContactUpdate);
Vue.component('sau-account-apitokens', _ApiTokens);

/**
 * Billing
 */
import _PaymentSummaryRHS from './components/billing/_PaymentSummaryRHS';
import Payment from './components/billing/Payment';
import PaymentComplete from './components/billing/PaymentComplete';
import PaymentFailed from './components/billing/PaymentFailed';
//Vue.component('sau-payment-aside', _PaymentSummaryRHS);
Vue.component('sau-payment', Payment);
Vue.component('sau-payment-complete', PaymentComplete);
Vue.component('sau-payment-failed', PaymentFailed);

/**
 * Services
 */
import AllServices from './components/service/All';
import Access from './components/service/Access';
import Allocation from './components/service/Allocation';
import Billing from './components/service/Billing';
import Network from './components/service/Network';
import Power from './components/service/Power';
import Summary from './components/service/Summary';
import System from './components/service/System';
import DNS from './components/service/DNS';
import ServiceResize from './components/service/Resize';
Vue.component('sau-services', AllServices);
Vue.component('sau-service-access', Access);
Vue.component('sau-service-allocation', Allocation);
Vue.component('sau-service-billing', Billing);
Vue.component('sau-service-network', Network);
Vue.component('sau-service-power', Power);
Vue.component('sau-service-summary', Summary);
Vue.component('sau-service-system', System);
Vue.component('sau-service-dns', DNS);
Vue.component('sau-service-resize', ServiceResize);

/**
 * Graphs
 */
import Bandwidth from './components/service/graphs/Bandwidth';
import DailyUsage from './components/service/graphs/DailyUsage';
import Port from './components/service/graphs/Port';
import Bar from './components/service/graphs/Bar';
Vue.component('sau-bandwidth-graph', Bandwidth);
Vue.component('sau-daily-usage-graph', DailyUsage);
Vue.component('sau-port-graphs', Port);
Vue.component('sau-bar-graph', Bar);

/**
 * Common
 */
import _CancellationPending from './components/service/common/_CancellationPending';
import _CancellationCheck from './components/service/common/_CancellationCheck';
import _Suspended from './components/service/common/_Suspended';
import _Status from './components/service/common/_Status';
import _System from './components/service/common/_System';
Vue.component('sau-cancellation-check', _CancellationCheck);
Vue.component('sau-cancellation-pending', _CancellationPending);
Vue.component('sau-suspended-service', _Suspended);
Vue.component('sau-service-status', _Status);
Vue.component('sau-service-common-system', _System);

/**
 * Domains
 */
import AllDomains from './components/domains/All';
import Details from './components/domains/Details';
import Contacts from './components/domains/Contacts';
import Password from './components/domains/Password';
import Nameservers from './components/domains/Nameservers';
import AutoRenewal from './components/domains/AutoRenewal';
import RegistrarLock from './components/domains/RegistrarLock';
Vue.component('sau-domains', AllDomains);
Vue.component('sau-domain-details', Details);
Vue.component('sau-domain-contacts', Contacts);
Vue.component('sau-domain-password', Password);
Vue.component('sau-domain-nameservers', Nameservers);
Vue.component('sau-domain-autorenewal', AutoRenewal);
Vue.component('sau-domain-registrarlock', RegistrarLock);

/**
 * Settings
 */
import UserSettings from './components/settings/UserSettings';
Vue.component('sau-user-settings', UserSettings);

/**
 * Ordering
 */
import SauOrder from './components/order/Order.vue';
Vue.component('sau-order', SauOrder);


/**
 * Global filters
 */
Vue.filter('CapitaliseFirst', function (string) {
    // ensure that a string has been passed to the filter
    return typeof string == 'string' ? string.charAt(0).toUpperCase() + string.slice(1) : string;
})

Vue.filter('Ucwords', function (string) {
    return _.startCase(string);
})

Vue.filter('Percent', function (number) {
    return parseFloat(number).toFixed(2) + '%';
})

Vue.filter('Kebab', function (string) {
    return _.kebabCase(string);
})

Vue.use(VueCurrencyFilter, { // currency display filter
    symbol: '$',
    thousandsSeparator: ',',
    fractionCount: 2,
    fractionSeparator: '.',
    symbolPosition: 'front',
    symbolSpacing: false
});

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

import Rollbar from 'vue-rollbar';
if (['staging', 'production'].includes(window.App.environment)) {
    Vue.use(Rollbar, {
        enabled: true,
        captureUncaught: true,
        source_map_enabled: true,
        environment: 'production',
        hostWhiteList: ['mysau.com.au'],
        captureUnhandledRejections: true,
        accessToken: 'b55e5338f6054f1b8dc02d17fba8f1e8',
        scrubFields: ['exp-month', 'exp-year', 'ccName', 'cvv', 'password', 'reEnterNewPassword', 'message'],
        payload: {
            client: {
                javascript: {
                    code_version: '1.0',
                },
            },
        },
    });

    Vue.config.errorHandler = function (err, vm, info) {
        Vue.rollbar.error(err);
    };
}
if ($('#app').length) {
    const app = new Vue({
        el: '#app',
        store,

        computed: {
            ccImageColoured() {
                return this.getCreditCardImage();
            }
        },
    });
}

import Order from './components/order/Order';
import VpsOrder from './components/order/vps/VpsOrder';
import VpsSelectProduct from './components/order/vps/VpsSelectProduct';
import VpsSelectOptions from './components/order/vps/VpsSelectOptions';
import OrderView from './components/order/View';
import OrderDedi from './components/order/Dedi';
import RTGDedi from './components/order/RTGDedi';

import DomainOrder from './components/order/DomainOrder'
import DomainRegister from './components/order/DomainRegister';
import DomainTransfer from './components/order/DomainTransfer';
import DomainRenew from './components/order/DomainRenew';

import Colocation from './components/order/Colocation';
import OrderComplete from './components/order/Complete';
import OrderingSidebar from './components/order/Sidebar';
// import MegaBundles from './components/order/MegaBundles';
import DediPreconfig from './components/order/DediPreconfig';
import SslCertificate from './components/order/SslCertificate';
import ManagedWordpress from './components/order/ManagedWordpress';
import OrderConfirmDomains from './components/order/ConfirmDomains';

Vue.component('sau-ordering-sidebar', OrderingSidebar);

const orderRoutes = [
    {
        path: '/order', name: 'Products', component: Order, children: [
            {
                path: '/order/vps',
                component: VpsOrder,
                children: [
                    { path: '', component: VpsSelectProduct },
                    { path: 'options', component: VpsSelectOptions },
                ],
            },
            // { path: '/order/mega-bundle', component: MegaBundles },
            { path: '/order/confirm-domains', component: OrderConfirmDomains },
            {
                path: '/order/domain', component: DomainOrder, children:
                [
                    { path: '', alias: '/order/domain/register', name: 'Register', component: DomainRegister },
                    { path: 'transfer', name: 'Transfer', component: DomainTransfer },
                    { path: 'renew', name: 'Renew', component: DomainRenew },
                ]
            },
            { path: '/order/view', name: 'Order Summary', component: OrderView },
            { path: '/order/ready-to-go', name: 'Ready to Go', component: RTGDedi },
            { path: '/order/colocation', name: 'Colocation', component: Colocation },
            { path: '/order/dedicated-server', name: 'Dedicated Servers', component: RTGDedi },
            { path: '/order/ssl-certificate', name: 'SslCertificate', component: SslCertificate },
            { path: '/order/dedicated-server/custom', name: 'Customise Server', component: OrderDedi },
            { path: '/order/managed-wordpress', name: 'Managed Wordpress', component: ManagedWordpress },
            { path: '/order/complete', name: 'Order Complete', component: OrderComplete },
            { path: '*', redirect: '/order' }

        ]
    }
];

const router = new VueRouter({
    routes: orderRoutes,
    mode: 'history',
    hashbang: false,
    scrollBehavior: function (to, from, savedPosition) {
        return { x: 0, y: 0 }
    },
});

if ($('#app-ordering').length) {
    const orderingApp = new Vue({
        el: '#app-ordering',
        router,
        store,
        data() {
            return {
                requiredFields: ['address1', 'city', 'postcode', 'state', 'country', 'phonenumber'],
            }
        },
        mounted() {
            this.getAccountHolder().then(response => { // preload the account holder info
                this.$store.commit('setAccountHolder', response.data);
            })
        },
        computed: {
            requiresAdditionalUserInformation() {
                return this.requiredFields
                    .map(field => this.accountHolder[field])
                    .some(detail => detail == '');
            },
            ccImageColoured() {
                return this.getCreditCardImage();
            }
        }
    });
}
